export default __webpack_public_path__ + "static/media/failMsg.759b396f.svg";